import type { Brand } from "@/types/brand";

export function normalizeBrandLabel(value: string | null | undefined): string {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/** Préremplit le select avec la marque source si elle existe déjà chez le vendeur. */
export function resolveSellerBrandId(options: {
  brandId?: number | null;
  brandName?: string | null;
  brands: Brand[];
}): string {
  const brands = options.brands;
  if (!brands.length) return "";

  if (options.brandId) {
    const byId = brands.find(
      (brand) => Number(brand.id) === Number(options.brandId)
    );
    if (byId) return String(byId.id);
  }

  const sourceName = normalizeBrandLabel(options.brandName);
  if (sourceName) {
    const byName = brands.find(
      (brand) => normalizeBrandLabel(brand.name) === sourceName
    );
    if (byName) return String(byName.id);
  }

  const defaultBrand = brands.find((brand) => brand.isDefault);
  if (defaultBrand) return String(defaultBrand.id);

  if (brands.length === 1) return String(brands[0].id);

  return "";
}

export function brandSelectOptions(brands: Brand[]) {
  return brands
    .slice()
    .sort((left, right) => {
      if (left.isDefault !== right.isDefault) {
        return left.isDefault ? -1 : 1;
      }
      return left.name.localeCompare(right.name, "fr", { sensitivity: "base" });
    })
    .map((brand) => ({
      value: String(brand.id),
      label: brand.isDefault ? `${brand.name} (défaut)` : brand.name,
    }));
}
